// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-expand-panel',
    // #endregion
    // #region Events
    emits: ['expanded', 'collapsed'],
    // #endregion
    // #region Properties
    props: {
        key: {
            type: String,
            required: false,
            default: ''
        },
        index: {
            type: Number,
            required: false,
            default: 0
        },
        expanded: {
            type: Boolean,
            required: false,
            default: false
        },
        arrowLocation: {
            type: String,
            required: false,
            default: 'right'
        },
    },
    data: () => ({
        _IsExpanded: false,
    }),
    created() {
        this._IsExpanded = this.expanded;
    },
    watch: {
        expanded: function (newVal, oldVal) {
            this._IsExpanded = newVal;
        }
    },
    // #endregion
    // #region Methodes
    methods: {
        toggle() {
            if (this._IsExpanded) {
                //Open
                this._IsExpanded = false;
                //Event
                this.$emit('collapsed', { key: this.key, index: this.index });
            }
            else {
                //Open
                this._IsExpanded = true;
                //Event
                this.$emit('expanded', { key: this.key, index: this.index });
            }
        }
    }
    // #endregion
});
// #endregion
